import React, { FC } from 'react';

import { Control, useForm } from 'react-hook-form';

import { DEAL_PARAMETERS_STATUS_OPTIONS } from 'constants/deals';
import { REQUIRED_MESSAGE } from 'constants/global';
import { UseModalReturnValues } from 'hooks/use-modal/useModal';
import { Option } from 'interfaces';
import { AlertModal, SelectFormInput } from 'shared-components';

import { TypographyVariants } from '../../../constants/shared/typography';

interface Props extends Omit<UseModalReturnValues, 'onOpen'> {
  handleChangeDealPlatformStatus: (id: string, status: string) => void;
  dealParametersId?: string;
  isLoading?: boolean;
}

const DealPlatformStatusChangeModal: FC<Props> = ({
  handleChangeDealPlatformStatus,
  dealParametersId,
  isLoading,
  ...modalProps
}) => {
  const { control, handleSubmit, watch, reset } = useForm({
    defaultValues: {
      dealStatus: null,
    },
  });

  const selectedDealStatus = watch('dealStatus', null) as Option | null;

  return (
    <AlertModal
      onSubmit={handleSubmit(() => {
        if (selectedDealStatus && dealParametersId) {
          handleChangeDealPlatformStatus(dealParametersId, selectedDealStatus.value);
          reset();
          modalProps.onClose();
        }
      })}
      isLoading={isLoading ? isLoading : false}
      title={'Please select a new deal parameters status'}
      submitButtonText={'Confirm'}
      modalClassName='min-w-[70%] 2xl:min-w-[1048px]'
      titleVariant={TypographyVariants.LARGE}
      hideIcon
      {...modalProps}
    >
      <form className='w-full mt-8 p-1'>
        <SelectFormInput
          label='Deal parameters status'
          placeholder='Deal parameters status'
          control={control as unknown as Control}
          name='dealStatus'
          options={DEAL_PARAMETERS_STATUS_OPTIONS}
          isClearable
          required
          validation={{ required: REQUIRED_MESSAGE }}
        />
      </form>
    </AlertModal>
  );
};

export default DealPlatformStatusChangeModal;
